var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:[_vm.baseCss, _vm.svg ? 'em-svg' : 'em', ("em-" + _vm.name), 'select-none'],style:({fontSize: (_vm.size + "em")}),attrs:{"aria-hidden":"true","aria-role":"presentation","aria-label":_vm.name.toUpperCase()}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cfa4bfd8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/bcq-ui/components/emoji/emoji.vue
// module id = null
// module chunks = 